// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import * as firebase from 'firebase'
// import { config } from '../firebase.js'
import { store } from './store/store'
import Buefy from 'buefy'
import router from './router'
import Aos from 'aos'

// Import global components
import Navigation from '@/components/Navigation.vue'

// Register global components
Vue.component('navigation', Navigation)

let config = {
  apiKey: 'AIzaSyDOjHB1_BV82TYm9FCZ0RKi-YDX3qAoCB4',
  authDomain: 'aino-michelsen.firebaseapp.com',
  databaseURL: 'https://aino-michelsen.firebaseio.com',
  projectId: 'aino-michelsen',
  storageBucket: '',
  messagingSenderId: '85911887116'
}

// Initialize Firebase
firebase.initializeApp(config)

// Buefy configurations
Vue.use(Buefy, { defaultIconPack: 'fa' })

// Aos configurations
Vue.use(Aos)

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js